/**
 * Where the bundled IRS schema package lives.
 *
 * The engine ships the XSD trees inside the npm package (schemas/TY2025, schemas/TY2026),
 * so nothing may be resolved from the working directory. This walks up from the compiled
 * module's own folder until it finds the shipped schemas, which makes the same code work
 * when running from src/ under vitest and from dist/ after a build.
 */
import * as fs from "fs";
import * as path from "path";

let cached: string | null = null;

/** Absolute path of the folder holding TY2025/ and TY2026/. */
export function defaultSchemaRoot(): string {
  if (cached) return cached;
  let dir = __dirname;
  for (let hop = 0; hop < 8; hop++) {
    const candidate = path.join(dir, "schemas");
    if (fs.existsSync(path.join(candidate, "TY2025"))) {
      cached = candidate;
      return cached;
    }
    const parent = path.dirname(dir);
    if (parent === dir) break;
    dir = parent;
  }
  // Nothing found: fall back to the package layout (two levels up from src/ or dist/).
  cached = path.join(__dirname, "..", "schemas");
  return cached;
}

/** Join a path inside the schema package. */
export function schemaPath(schemaRoot: string | undefined, ...parts: string[]): string {
  return path.join(schemaRoot ?? defaultSchemaRoot(), ...parts);
}
